var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    _vm._l(5, function(i) {
      return _c("div", { key: i, staticClass: "px-2" }, [
        _c("div", {
          staticClass: "skeleton-box",
          staticStyle: {
            height: "25px",
            "margin-bottom": "10px",
            "background-color": "#646464"
          }
        }),
        _vm._v(" "),
        _c("div", {
          staticClass: "skeleton-box",
          staticStyle: {
            width: "85%",
            height: "25px",
            "margin-left": "40px",
            "margin-bottom": "10px",
            "background-color": "#646464"
          }
        }),
        _vm._v(" "),
        _c("div", {
          staticClass: "skeleton-box",
          staticStyle: {
            width: "85%",
            height: "25px",
            "margin-left": "40px",
            "margin-bottom": "10px",
            "background-color": "#646464"
          }
        })
      ])
    })
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-1858519f", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1858519f","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/application-manager/detail/app-tabs/partials/loading/skeletonSidebar.vue
// module id = null
// module chunks = 